<agr-form-dialog [formGroup]="formGroup" [contentSpacing]="false" [data]="data" (confirm)="process($event)" (cancel)="cancel($event)" (alt)="alt($event)">
  <mat-accordion multi="true">
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'blightProducts' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngTemplateOutlet="blightProducts" />
    </mat-expansion-panel>

    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'bemProducts' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-bem-products [products]="data.bemProducts" />
    </mat-expansion-panel>

    @if (data.downyMildewActivated) {
      <mat-expansion-panel class="activation-panel" [disabled]="true" [hideToggle]="true" data-test="downy-mildew-panel">
        <mat-expansion-panel-header class="activation-panel-header">
          <mat-panel-title class="activation-panel-title">
            {{ 'downyMildewProducts' | translate }}
          </mat-panel-title>
          <mat-panel-description class="activation-panel-status">
            <mat-icon class="activation-panel-check" data-test="downy-mildew-activated-icon" color="primary">check</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
    }

    @if (data.virusMonitorActivated) {
      <mat-expansion-panel class="activation-panel" [disabled]="true" [hideToggle]="true" data-test="virus-monitor-panel">
        <mat-expansion-panel-header class="activation-panel-header">
          <mat-panel-title class="activation-panel-title">
            {{ 'virusMonitorProducts' | translate }}
          </mat-panel-title>
          <mat-panel-description class="activation-panel-status">
            <mat-icon class="activation-panel-check" data-test="virus-monitor-activated-icon" color="primary">check</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
    }
  </mat-accordion>
</agr-form-dialog>

<ng-template #blightProducts>
  <div data-test="customer-product-inventory-table">
    @if ((filteredDigitalProductSubscriptions$ | async)?.length === 0 && !hasFilter) {
      <p class="wrapper--spacing-horizontal">
        {{ 'noProductSubscriptions' | translate }}
      </p>
    }
    @if ((filteredDigitalProductSubscriptions$ | async)?.length > 0 || hasFilter) {
      <mat-table [dataSource]="filteredDigitalProductSubscriptions$" style="min-width: 720px">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> {{ 'name' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.skuName }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="includeInOrder">
          <mat-header-cell *matHeaderCellDef>{{ 'includeInOrder' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [formControl]="getIncludeInOrderControl(element.index)"></mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="totalRequisite">
          <mat-header-cell *matHeaderCellDef>{{ 'totalRequisite' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.totalRequisite | agrNumber: '1.0-2' }} {{ 'unit.' + element.unitOfMeasurement | translate }}</mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="correction">
          <mat-header-cell *matHeaderCellDef>{{ 'correction' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="mat-input-cell">
            <mat-form-field appearance="fill" class="dialog-product-correction-input full-width-field spacing--padding-right" style="box-sizing: border-box">
              <mat-label>{{ 'correction' | translate }}</mat-label>
              <input
                matInput
                [step]="0.01"
                maxlength="7"
                agrNumber
                [formControl]="getCorrectionControl(element.index)"
                [attr.data-test]="'correction-dialog-input-' + element.index"
              />
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="alreadyOrdered">
          <mat-header-cell *matHeaderCellDef>{{ 'alreadyOrdered' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.alreadyOrdered | agrNumber: '1.0-2' }} {{ 'unit.' + element.unitOfMeasurement | translate }}</mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="toOrder">
          <mat-header-cell *matHeaderCellDef>{{ 'toOrder' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ getToOrderAmount(element.index, element.totalRequisite, element.alreadyOrdered) | agrNumber: '1.0-2' }}
            {{ 'unit.' + element.unitOfMeasurement | translate }}
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    }
  </div>
</ng-template>
